import ApplicationContextProvider from './context';

interface IApplicationProvider {
  children: any;
}

const ApplicationProvider = (props: IApplicationProvider) => {
  return (
    <ApplicationContextProvider>{props.children}</ApplicationContextProvider>
  );
};

export default ApplicationProvider;